const reportTheme = {
  id: 306,
  name: "Line",
  slug: "line",
  title: null,
  description: null,
  clientID: 1,
  use_for_summary: false,
  allow_for_custom: false,
  country: "England",
};

const items = [
  {
    id: 62,
    reportThemeID: 306,
    text: null,
    chartType: "Line",
    chartRef: "1669103534594",
    chartDescription: "<p>Unemployment benefit (JSA and Universal Credit)</p>",
    chartXLabel: null,
    chartYLabel: "Percent %",
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 2,
    timeSeries: true,
    itemName: "Unemployment Benefit Claimants (time series)",
    itemSource: "Department for Work and Pensions (DWP)",
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    indicators: [
      {
        id: 3548,
        indicatorHTMLTableRef: null,
        chartRef: "1669103534594",
        indicatorCode: "claimant_count*dr",
        indicatorDate: "2020-01-01,2050-01-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 792,
        indicatorName:
          "Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants)",
        source: "Department for Work and Pensions (DWP)",
        date: "2020-01-01",
        decimalPlaces: 2,
        dateCoverageText: "Jan-2020",
      },
      {
        id: 3548,
        indicatorHTMLTableRef: null,
        chartRef: "1669103534594",
        indicatorCode: "claimant_count*dr",
        indicatorDate: "2020-01-01,2050-01-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 792,
        indicatorName:
          "Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants)",
        source: "Department for Work and Pensions (DWP)",
        date: "2020-02-01",
        decimalPlaces: 2,
        dateCoverageText: "Feb-2020",
      },
      {
        id: 3548,
        indicatorHTMLTableRef: null,
        chartRef: "1669103534594",
        indicatorCode: "claimant_count*dr",
        indicatorDate: "2020-01-01,2050-01-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 792,
        indicatorName:
          "Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants)",
        source: "Department for Work and Pensions (DWP)",
        date: "2020-03-01",
        decimalPlaces: 2,
        dateCoverageText: "Mar-2020",
      },
      {
        id: 3548,
        indicatorHTMLTableRef: null,
        chartRef: "1669103534594",
        indicatorCode: "claimant_count*dr",
        indicatorDate: "2020-01-01,2050-01-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 792,
        indicatorName:
          "Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants)",
        source: "Department for Work and Pensions (DWP)",
        date: "2020-04-01",
        decimalPlaces: 2,
        dateCoverageText: "Apr-2020",
      },
      {
        id: 3548,
        indicatorHTMLTableRef: null,
        chartRef: "1669103534594",
        indicatorCode: "claimant_count*dr",
        indicatorDate: "2020-01-01,2050-01-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 792,
        indicatorName:
          "Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants)",
        source: "Department for Work and Pensions (DWP)",
        date: "2020-05-01",
        decimalPlaces: 2,
        dateCoverageText: "May-2020",
      },
    ],
  },
  {
    id: 301,
    reportThemeID: 306,
    text: null,
    chartType: "Line",
    chartRef: "16819170424177",
    chartDescription: "<p>12 month total crime rate (time series)</p>",
    chartXLabel: null,
    chartYLabel: "Crimes per 1,000 population",
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 2,
    timeSeries: true,
    itemName: "12 month total crime rate (time series)",
    itemSource: "Police UK",
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: true,
    indicators: [
      {
        id: 301,
        indicatorHTMLTableRef: null,
        chartRef: "16819170424177",
        indicatorCode: "total_crime_police_uk_12_month*dr",
        indicatorDate: "asc",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 640,
        indicatorName: "Total crime offences (12 month total)",
        source: "Police UK",
        date: "2018-09-01",
        decimalPlaces: 1,
        dateCoverageText: "Sep-2018 to Aug-2019",
      },
      {
        id: 301,
        indicatorHTMLTableRef: null,
        chartRef: "16819170424177",
        indicatorCode: "total_crime_police_uk_12_month*dr",
        indicatorDate: "asc",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 640,
        indicatorName: "Total crime offences (12 month total)",
        source: "Police UK",
        date: "2018-12-01",
        decimalPlaces: 1,
        dateCoverageText: "Dec-2018 to Nov-2019",
      },
      {
        id: 301,
        indicatorHTMLTableRef: null,
        chartRef: "16819170424177",
        indicatorCode: "total_crime_police_uk_12_month*dr",
        indicatorDate: "asc",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 640,
        indicatorName: "Total crime offences (12 month total)",
        source: "Police UK",
        date: "2019-03-01",
        decimalPlaces: 1,
        dateCoverageText: "Mar-2019 to Feb-2020",
      },
      {
        id: 301,
        indicatorHTMLTableRef: null,
        chartRef: "16819170424177",
        indicatorCode: "total_crime_police_uk_12_month*dr",
        indicatorDate: "asc",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 640,
        indicatorName: "Total crime offences (12 month total)",
        source: "Police UK",
        date: "2019-06-01",
        decimalPlaces: 1,
        dateCoverageText: "Jun-2019 to May-2020",
      },
      {
        id: 301,
        indicatorHTMLTableRef: null,
        chartRef: "16819170424177",
        indicatorCode: "total_crime_police_uk_12_month*dr",
        indicatorDate: "asc",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 640,
        indicatorName: "Total crime offences (12 month total)",
        source: "Police UK",
        date: "2019-09-01",
        decimalPlaces: 1,
        dateCoverageText: "Sep-2019 to Aug-2020",
      },
    ],
  },
];

const comparatorAreaCodes = ["CSTM5160", "E10000012", "E10000011"];

const comparatorsList = [
  { area_code: "CSTM5160", area_name: "Comparator 1" },
  { area_code: "E10000012", area_name: "Comparator 2" },
  { area_code: "E10000011", area_name: "Comparator 3" },
];

// Indicator values for all line chart examples (time series data)
// Key pattern: <area>.<indicatorCode>.<date>.<indicatorName>.rate
const indicatorValues = {
  // Example 1: Unemployment benefit (JSA and Universal Credit) - time series
  "CSTM5160.claimant_count*dr.2020-01-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "2.70%",
  "E10000012.claimant_count*dr.2020-01-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "2.10%",
  "E10000011.claimant_count*dr.2020-01-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "2.40%",

  "CSTM5160.claimant_count*dr.2020-02-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "2.80%",
  "E10000012.claimant_count*dr.2020-02-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "2.15%",
  "E10000011.claimant_count*dr.2020-02-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "2.45%",

  "CSTM5160.claimant_count*dr.2020-03-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "3.10%",
  "E10000012.claimant_count*dr.2020-03-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "2.30%",
  "E10000011.claimant_count*dr.2020-03-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "2.60%",

  "CSTM5160.claimant_count*dr.2020-04-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "4.20%",
  "E10000012.claimant_count*dr.2020-04-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "3.50%",
  "E10000011.claimant_count*dr.2020-04-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "3.80%",

  "CSTM5160.claimant_count*dr.2020-05-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "4.80%",
  "E10000012.claimant_count*dr.2020-05-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "4.10%",
  "E10000011.claimant_count*dr.2020-05-01.Unemployment benefit claimants (Jobseekers Allowance and out of work Universal Credit claimants).rate":
    "4.30%",

  // Example 2: 12 month total crime rate (time series)
  "CSTM5160.total_crime_police_uk_12_month*dr.2018-09-01.Total crime offences (12 month total).rate":
    "160.8",
  "E10000012.total_crime_police_uk_12_month*dr.2018-09-01.Total crime offences (12 month total).rate":
    "107.9",
  "E10000011.total_crime_police_uk_12_month*dr.2018-09-01.Total crime offences (12 month total).rate":
    "110.9",

  "CSTM5160.total_crime_police_uk_12_month*dr.2018-12-01.Total crime offences (12 month total).rate":
    "165.2",
  "E10000012.total_crime_police_uk_12_month*dr.2018-12-01.Total crime offences (12 month total).rate":
    "109.5",
  "E10000011.total_crime_police_uk_12_month*dr.2018-12-01.Total crime offences (12 month total).rate":
    "113.2",

  "CSTM5160.total_crime_police_uk_12_month*dr.2019-03-01.Total crime offences (12 month total).rate":
    "168.5",
  "E10000012.total_crime_police_uk_12_month*dr.2019-03-01.Total crime offences (12 month total).rate":
    "111.8",
  "E10000011.total_crime_police_uk_12_month*dr.2019-03-01.Total crime offences (12 month total).rate":
    "115.6",

  "CSTM5160.total_crime_police_uk_12_month*dr.2019-06-01.Total crime offences (12 month total).rate":
    "172.1",
  "E10000012.total_crime_police_uk_12_month*dr.2019-06-01.Total crime offences (12 month total).rate":
    "114.3",
  "E10000011.total_crime_police_uk_12_month*dr.2019-06-01.Total crime offences (12 month total).rate":
    "118.4",

  "CSTM5160.total_crime_police_uk_12_month*dr.2019-09-01.Total crime offences (12 month total).rate":
    "175.6",
  "E10000012.total_crime_police_uk_12_month*dr.2019-09-01.Total crime offences (12 month total).rate":
    "116.9",
  "E10000011.total_crime_police_uk_12_month*dr.2019-09-01.Total crime offences (12 month total).rate":
    "121.2",
};

export default {
  reportTheme,
  items,
  indicatorValues,
  comparatorsList,
  comparatorAreaCodes,
};
